const selectCartMods = uxModsData => uxModsData.cartMods || [];
const selectCartEnvironmentData = uxModsData =>
  uxModsData.cartEnvironmentData || {};
const selectModsByItemId = (uxModsData, itemId) =>
  uxModsData.itemMods[itemId] || [];
const selectItemEnvironmentDataByItemId = (uxModsData, itemId) =>
  uxModsData.itemEnvironmentData[itemId] || {};
const selectModsByItemGroupId = (uxModsData, groupId) =>
  uxModsData.itemGroupMods[groupId] || [];
const selectItemGroupEnvironmentDataByGroupId = (uxModsData, groupId) =>
  uxModsData.itemGroupEnvironmentData[groupId] || {};

export default {
  selectCartMods,
  selectCartEnvironmentData,
  selectModsByItemId,
  selectItemEnvironmentDataByItemId,
  selectModsByItemGroupId,
  selectItemGroupEnvironmentDataByGroupId,
};
